import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: any = {
  update: { updating: false, success: false },
  create: { creating: false, success: false },
  data: [],
  loading: false,
  error: null,
};
const drivercallSlice = createSlice({
  name: "drivercall",
  initialState,
  reducers: {
    getDrivercallRequest(state) {
      state.loading = true;
      state.error = null;
    },
    getDrivercallSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
    },
    getDrivercallFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    addDrivercallRequest(state) {
      state.create = { creating: true, success: false };
    },
    addDrivercallSuccess(state: any, action) {
      state.create = { creating: false, success: true };
    },
    addDrivercallFailure(state, action) {
      state.create = { creating: false, success: false };
    },
  },
});
export const {
  getDrivercallRequest,
  getDrivercallSuccess,
  getDrivercallFailure,
  addDrivercallRequest,
  addDrivercallSuccess,
  addDrivercallFailure,
} = drivercallSlice.actions;
export default drivercallSlice.reducer;
